const state = {
  processing: false,
  bulkProcessing: false,
  invoices: [],
  showInvoices: false,
};

export default state;
